import type { Marker } from './types.js';

/**
 * Marcadores anatomicos M1-M18 da Estacao 2 (folha 2 da ficha v1.0).
 * Sao colados no lado ESQUERDO do animal e precisam estar visiveis na foto de
 * perfil; os angulos extraidos por fotogrametria dependem deles.
 *
 * NOTA: M10 (tuberosidade sacral) e M15 (ponta do jarrete) nao participam de
 * nenhum angulo do protocolo v1.0. Sao mantidos porque M10 e a referencia da
 * altura de garupa e M15 delimita C_TIB/C_CANP.
 */
export const markersV1: Marker[] = [
  ['M1', 'Nuca'],
  ['M2', 'Cernelha'],
  ['M3', 'Extremidade dorsal da espinha da escapula'],
  ['M4', 'Ponta da espadua'],
  ['M5', 'Cotovelo (epicondilo)'],
  ['M6', 'Carpo'],
  ['M7', 'Boleto anterior'],
  ['M8', 'Coroa anterior'],
  ['M9', 'Ultima vertebra toracica'],
  ['M10', 'Tuberosidade sacral'],
  ['M11', 'Ponta da anca'],
  ['M12', 'Trocanter maior'],
  ['M13', 'Ponta da nadega'],
  ['M14', 'Joelho (condilo tibial)'],
  ['M15', 'Ponta do jarrete'],
  ['M16', 'Maleolo lateral da tibia'],
  ['M17', 'Boleto posterior'],
  ['M18', 'Coroa posterior'],
].map(([code, label], i) => ({ code: code as string, label: label as string, sortOrder: i + 1 }));
